import { cn } from '@/lib/utils'

/**
 * The red rule + tracked caps label that introduces each section. `centered`
 * adds a matching rule on the right, as the sectors heading uses.
 *
 * The rules themselves are `::before`/`::after` on `.eyebrow` in globals.css.
 */
export function SectionEyebrow({
  children,
  centered = false,
  className,
}: {
  children: React.ReactNode
  centered?: boolean
  className?: string
}) {
  return <p className={cn('eyebrow', centered && 'eyebrow-centered', className)}>{children}</p>
}
